import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';
import { DollarCircle } from 'iconsax-react';

interface Props {
  open: boolean;
  handleClose: () => void;
  status: 'success' | 'failed' | '';
  totalOrders?: number; // Number of orders placed (optional, only used if status is 'success')
  successFulOrders: number;
}

export default function OrderPlacedAlert({ open, handleClose, status, totalOrders, successFulOrders }: Props) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="order-placed-title"
      aria-describedby="order-placed-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color={status === 'success' ? 'success' : 'error'} sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <DollarCircle variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              {status === 'success' ? 'Orders Placed' : 'Order Failed'}
            </Typography>
            <Typography align="center">
              {status === 'success'
                ? `Out of ${totalOrders} ${totalOrders === 1 ? 'order' : 'orders'}, ${successFulOrders} ${
                    successFulOrders === 1 ? 'order' : 'orders'
                  } were successfully placed!`
                : 'Sorry, your order failed to be placed. Please try again later.'}
            </Typography>
          </Stack>

          <Button fullWidth onClick={handleClose} color="primary" variant="contained" autoFocus>
            OK
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
